import React from 'react';
import { Box, Flex } from '@mantine/core';
import { IconBuildingSkyscraper, IconCalendarStats, IconStairs } from '@tabler/icons-react';
import type { ICostoBaseCapacidad, ICostoBaseRecorrido, IIncrementoAnualServicio } from '../../../modelos/CotizadorServicios/entidades/IParametrosServicios';
import { TarjetaTablaEditable } from '../../../globales/componentes/tabla/tarjetaTablaEditable';
import type { ITablaEditable } from '../../../globales/componentes/tabla/useEdicionFilas';
import { columnasCostoCapacidad, columnasCostoRecorrido, columnasIncrementoAnual } from './constantesTablasParametros';

const COLUMNAS_COSTO_CAPACIDAD = columnasCostoCapacidad();
const COLUMNAS_COSTO_RECORRIDO = columnasCostoRecorrido();
const COLUMNAS_INCREMENTO_ANUAL = columnasIncrementoAnual();

interface CostosBaseServiciosVistaProps {
    costosCapacidad: ITablaEditable<ICostoBaseCapacidad>;
    costosRecorrido: ITablaEditable<ICostoBaseRecorrido>;
    incrementosAnuales: ITablaEditable<IIncrementoAnualServicio>;
}

/** Alto de cada tarjeta: el de la pantalla cuando van lado a lado; el de su contenido cuando van apiladas. */
const columna = { flex: 1, minWidth: 0, minHeight: 0 };

/** Pestaña "Costos e Incrementos": matrices de costo base y de incremento anual. */
export const CostosBaseServiciosVista: React.FC<CostosBaseServiciosVistaProps> = ({ costosCapacidad, costosRecorrido, incrementosAnuales }) => (
    <Flex direction={{ base: 'column', lg: 'row' }} gap="md" h={{ base: 'auto', lg: '100%' }}>
        <Box style={columna}>
            <TarjetaTablaEditable
                titulo="Costo Base Ascensores"
                icono={<IconBuildingSkyscraper size={18} />}
                nota="Se toma la fila con la capacidad igual o inmediatamente mayor a la del equipo."
                tabla={costosCapacidad}
                columnas={COLUMNAS_COSTO_CAPACIDAD}
            />
        </Box>
        <Box style={columna}>
            <TarjetaTablaEditable
                titulo="Costo Base Escaleras"
                icono={<IconStairs size={18} />}
                nota="Rampas y andenes aplican además el factor de su tipo de equipo."
                tabla={costosRecorrido}
                columnas={COLUMNAS_COSTO_RECORRIDO}
            />
        </Box>
        <Box style={columna}>
            <TarjetaTablaEditable
                titulo="Incremento Anual"
                icono={<IconCalendarStats size={18} />}
                nota="Los años posteriores al último registrado usan el incremento de ese último año."
                tabla={incrementosAnuales}
                columnas={COLUMNAS_INCREMENTO_ANUAL}
            />
        </Box>
    </Flex>
);
